import styled from 'styled-components';

export const SalesAssistantDrawerWrapper = styled.span``;
